module.exports = __webpack_public_path__ + "static/action-banner-6b8b1fea58699bd630b72fef2d264760.png";